import { STATUS } from "@/utils/constants";

import {
  SET_IS_FETCHING_TEMPLATES_STATUS,
  SET_TEMPLATES,
  SET_LOADING_STATE,
  SET_LOADING_STATE_BY_UID,
  SET_LOADING_STATE_ON_NEW_UID,
  SET_IS_SELECT_TEMPLATE_MODAL_VISIBLE,
  RESET,
} from "./template-lists.actionTypes";

const initialState = {
  isFetchingTemplatesStatus: STATUS.IDLE,
  templates: [],
  loading: {},
  isSelectTemplateModalVisible: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_FETCHING_TEMPLATES_STATUS: {
      return {
        ...state,
        isFetchingTemplatesStatus: action.payload,
      };
    }

    case SET_TEMPLATES: {
      return {
        ...state,
        templates: action.payload,
      };
    }

    case SET_IS_SELECT_TEMPLATE_MODAL_VISIBLE: {
      return {
        ...state,
        isSelectTemplateModalVisible: action.payload,
      };
    }

    case SET_LOADING_STATE: {
      return {
        ...state,
        loading: action.payload.reduce((acc, item) => {
          acc[item] = {
            duplicating: STATUS.IDLE,
            deleting: STATUS.IDLE,
          };

          return acc;
        }, {}),
      };
    }

    case SET_LOADING_STATE_BY_UID: {
      const { uid, key, value } = action.payload;
      return {
        ...state,
        loading: {
          ...state.loading,
          [uid]: {
            ...state.loading[uid],
            [key]: value,
          },
        },
      };
    }

    case SET_LOADING_STATE_ON_NEW_UID: {
      const { uid } = action.payload;
      return {
        ...state,
        loading: {
          ...state.loading,
          [uid]: {
            duplicating: STATUS.IDLE,
            deleting: STATUS.IDLE,
          },
        },
      };
    }

    case RESET: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};
